import { useCurrentBrandData } from "lib/auth/currentUserHooks";
import {
  BrandQuota,
  getQuotaLimits,
  getQuotaState,
  QuotaLimitByQuota,
} from "./quotas";

/** Returns quota limits from the current brand cache; page queries should fetch usage counts only. */
export function useCurrentBrandQuotaLimits(): QuotaLimitByQuota {
  const accessPlan = useCurrentBrandData()?.accessPlan;
  return getQuotaLimits(accessPlan);
}

/** Builds quota state from current brand cached plan limits and caller-supplied volatile usage. */
export function useCurrentBrandQuotaState(
  usedCount: number | null | undefined,
  quota: BrandQuota,
) {
  const brandData = useCurrentBrandData();
  const accessPlan = brandData?.accessPlan;
  const quotaLimits = getQuotaLimits(accessPlan);

  return getQuotaState({
    limit: quotaLimits[quota],
    planType: accessPlan?.planType,
    used: usedCount,
  });
}

export function useIsInvalidSubscription() {
  const brand = useCurrentBrandData();
  const { isSubscriptionValid } = brand || {};
  if (typeof isSubscriptionValid !== "boolean") return;
  return !isSubscriptionValid;
}
